import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'

// components
import { CButton } from '@coreui/react-pro'
import AppCard from '../../components/AppCard'
import AppTable from '../../components/AppTable'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from 'src/components/details/employee-details/AppDetails';
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'
import AppModalFilePreview from 'src/components/modal/AppModalFilePreview';
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// helpers
import Axios from '../../helpers/axios'
import { columnPayrollList, columnSalaryDetailsList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from 'src/helpers/format-queries'
import useToastMessage from 'src/helpers/toast-message'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

const EmployeeDetails = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const { id } = params
  const { showError } = useToastMessage();

  const [employeeDetail, setEmployeeDetail] = useState('')

  const [payrollList, setPayrollList] = useState([])
  const [payrollListCount, setPayrollListCount] = useState(0);
  const [payrollListPerPage, setPayrollListPerPage] = useState(10);
  const [activePayrollListPage, setActivePayrollListPage] = useState(1);
  const [searchPayrollListFilter, setSearchPayrollListFilter] = useState("");
  const [columnPayrollListSorter, setColumnPayrollListSorter] = useState({ column: "createdAt", state: "DESC" });

  const [salaryDetailsList, setSalaryDetailsList] = useState([])
  const [salaryDetailsListCount, setSalaryDetailsListCount] = useState(0);
  const [salaryDetailsListPerPage, setSalaryDetailsListPerPage] = useState(10);
  const [activeSalaryDetailsListPage, setActiveSalaryDetailsListPage] = useState(1);
  const [searchSalaryDetailsListFilter, setSearchSalaryDetailsListFilter] = useState("");
  const [columnSalaryDetailsListSorter, setColumnSalaryDetailsListSorter] = useState({ column: "createdAt", state: "DESC" });

  const [openFilePreview, setOpenFilePreview] = useState(false)
  const [showConfirmView, setShowConfirmView] = useState({ show: false, type: '', item: {} }) 

  const columnPayrollDetails = columnPayrollList?.filter((col) => col?.key !== 'action')

  const handleCardHeaderButton = () => {
    navigate(`/employee/edit/${id}`)
  }

  useEffect(() => {
    fetchDetailEmployee()
  }, [id]);

  const handleQueriesPayroll = () => {
    let queries = {
      search: searchPayrollListFilter,
      limit: payrollListPerPage,
      offset: payrollListPerPage * activePayrollListPage - payrollListPerPage,
      sort:
        (columnPayrollListSorter &&
          `${columnPayrollListSorter.column}%${columnPayrollListSorter.state}`) ||
        "",
      employee_id: id
    };
    queries = formUrlQuery(queries);

    return queries
  }

  const handleQueriesSalaryDetails = () => {
    let queries = {
      search: searchSalaryDetailsListFilter,
      limit: salaryDetailsListPerPage,
      offset: salaryDetailsListPerPage * activeSalaryDetailsListPage - salaryDetailsListPerPage,
      sort:
        (columnSalaryDetailsListSorter &&
          `${columnSalaryDetailsListSorter.column}%${columnSalaryDetailsListSorter.state}`) ||
        "",
      employee_id: id
    };
    queries = formUrlQuery(queries);

    return queries
  }

  useEffect(() => {
    let queries = handleQueriesPayroll()
    fetchAllPayroll(queries)
  }, [
    searchPayrollListFilter,
    payrollListPerPage,
    activePayrollListPage,
    columnPayrollListSorter
  ])

  useEffect(() => {
    let queries = handleQueriesSalaryDetails()
    fetchAllSalaryDetails(queries)
  }, [
    searchSalaryDetailsListFilter,
    salaryDetailsListPerPage,
    activeSalaryDetailsListPage,
    columnSalaryDetailsListSorter
  ])

  const fetchDetailEmployee = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/employee/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setEmployeeDetail(data?.value)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const fetchAllPayroll = (queries) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/payroll?${queries}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setPayrollList(data?.value)
          if (activePayrollListPage === 1) {
            setPayrollListCount(data?.count)
          }
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleSearchItemsPayroll = (search) => {
    setActivePayrollListPage(1)
    setSearchPayrollListFilter(search);
  }

  const fetchAllSalaryDetails = (queries) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/employee/salarydetails/list?${queries}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setSalaryDetailsList(data?.value)
          if (activePayrollListPage === 1) {
            setSalaryDetailsListCount(data?.count)
          }
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleSearchItemsSalaryDetails = (search) => {
    setActiveSalaryDetailsListPage(1)
    setSearchSalaryDetailsListFilter(search);
  }

  const handleOnRowPayrollClick = (item, columnName) => {
    if (columnName !== 'action') {
      setShowConfirmView({ show: true, type: 'payroll', item })
    }
  }

  return (
    <>
      {openFilePreview && (
        <AppModalFilePreview
          setOpenFilePreview={setOpenFilePreview}
          file={openFilePreview}
        />
      )}
      {
        showConfirmView.show && showConfirmView?.type === 'payroll' && (
          <AppModalConfirmation 
            confirmationType='detail-payroll'
            itemName="detail-payroll"
            itemDetails={showConfirmView.item}
            itemType={showConfirmView.type}
            showModal={showConfirmView}
            setShowModal={setShowConfirmView}
            handleViewFile={setOpenFilePreview}
          />
        )
      }
      <div className='d-grid gap-2 d-flex justify-content-start mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/employee/list')}>
          Back
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={
          <AppCardHeader
            headerTitle={<h4>Employee Details</h4>}
            headerButton="Edit"
            handleCardHeaderButton={handleCardHeaderButton}
          />
        }
        bodyContent={
          <AppDetails
            employeeDetails={employeeDetail}
            handleViewFile={setOpenFilePreview}
          />
        }
        lowerBodyContent={
          <>
            <AppCard
              className='mt-4 mb-4'
              headerTitle={<h4>Salary Details</h4>}
              bodyContent={
                <AppTable
                  salaryDetailsListPage
                  tableFilter
                  tableColumns={columnSalaryDetailsList}
                  tableContent={salaryDetailsList}
                  contentPerPage={salaryDetailsListPerPage}
                  contentCount={salaryDetailsListCount}
                  activeContentPage={activeSalaryDetailsListPage}
                  searchContentFilter={searchSalaryDetailsListFilter}
                  setSearchContentFilter={handleSearchItemsSalaryDetails}
                  setActiveContentPage={setActiveSalaryDetailsListPage}
                  setContentPerPage={setSalaryDetailsListPerPage}
                  setColumnContentSorter={setColumnSalaryDetailsListSorter}
                />
              }
            />
            <AppCard 
              className='mb-4'
              headerTitle={<h4>Attachments</h4>}
              bodyContent={
                <>
                  {
                    employeeDetail?.attachments?.length > 0 ? (
                      <FormFileThumbnail 
                        name='employee_attachments'
                        colSize='4'
                        files={employeeDetail?.attachments}
                        className='justify-content-start align-items-center'
                        isDetailPage={true}
                        handleViewFile={setOpenFilePreview}
                      />
                    )
                    : (
                      <>Not Found</>
                    )
                  }
                </>
              }
            />
            <AppCard
              className='mt-4 mb-4'
              headerTitle={<h4>Payrolls</h4>}
              bodyContent={
                <AppTable
                  payrollListPage
                  tableFilter
                  tableColumns={columnPayrollDetails}
                  tableContent={payrollList}
                  contentPerPage={payrollListPerPage}
                  contentCount={payrollListCount}
                  activeContentPage={activePayrollListPage}
                  searchContentFilter={searchPayrollListFilter}
                  setSearchContentFilter={handleSearchItemsPayroll}
                  setActiveContentPage={setActivePayrollListPage}
                  setContentPerPage={setPayrollListPerPage}
                  setColumnContentSorter={setColumnPayrollListSorter}
                  handleOnRowClick={handleOnRowPayrollClick}
                  isClickable={true}
                />
              }
            />
          </>
        }
      />
    </>
  )
}

export default EmployeeDetails